export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:beforeMount', async () => {
    const couponStore = useCouponStore()

    const coupon = couponStore.getCouponCookie()
    if (coupon)
      couponStore.setCoupon(coupon)
  })
})
